import type { CellValueProps as BaseCellValueProps } from "@stepfinance/react";
import { BaseCellValue } from "@stepfinance/react";
import type { FC } from "react";
import React from "react";

import { useAppConfig } from "../../contexts/app/config";
import { useCalculatePriceForDisplayCurrency } from "../../hooks";

type CellValueProps = Omit<BaseCellValueProps, "displayCurrencyValueFunction" | "hideableValueWrapper">;

const CellValue: FC<CellValueProps> = (props) => {
  const { hideableValueWrapper } = useAppConfig();
  const calculatePriceForDisplayCurrency = useCalculatePriceForDisplayCurrency();

  return (
    <BaseCellValue
      hideableValueWrapper={hideableValueWrapper}
      displayCurrencyValueFunction={calculatePriceForDisplayCurrency}
      {...props}
    />
  );
};

export default CellValue;
